import React from 'react'
import { Link } from 'react-router-dom'

function Banner({data}) {
    console.log(data);
    
  return (
    <div className="ttm-page-title-row ttm-bg ttm-bgimage-yes ttm-bgcolor-darkgrey clearfix">
    <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-12">
          <div className="ttm-page-title-row-inner">
            <div className="page-title-heading">
              <h2 className="title">{data?.title}</h2>
            </div>
            <div className="breadcrumb-wrapper">
              <span>
                <Link to="/">Home</Link>
              </span>
              <span>{data?.title}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default Banner